module.exports = __webpack_public_path__ + "img/nodata.59d7844e.png";